module.exports = __webpack_public_path__ + "img/pizzeriano3-nachspeisen.3433ec42.jpg";